















































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { storeKepatuhanVisiteDpjp } from "@/store/modules/KepatuhanVisiteDpjpStore";
import { userModule } from "@/store/modules/user";
import Service from "@/services/KepatuhanVisiteDpjpService";
import Referensi from "@/services/Referensi";
import http from "@/axios/http-common";

@Component
export default class KepatuhanVisiteDpjpForm extends Vue {
  @Prop({ default: null }) sessionData!: any;

  storeModule = storeKepatuhanVisiteDpjp;
  tabIndex = 0;
  saving = false;
  importing = false;
  pullingSoap = false;
  signing = false;
  pullSoapMessage = "";
  showPullSoapSnackbar = false;

  session: any = null;

  form: any = {
    tanggal_observasi: localISODate(),
    nama_petugas_id: null,
    nama_petugas: "",
    pic_nama: "",
    unit_ruang_rawat: "",
    unit_ruang_rawat_nama: "",
    nama_dokter_spesialis_id: null,
    nama_dokter_spesialis: "",
    spesialisasi: "",
    timezone: "WIB",
    status_dokter_hari_ini: "aktif",
    batas_waktu_standar: "14:00:00",
    target_persen: 80,
    // Analisa
    penyebab_lainnya_detail: "",
    rencana_tindak_lanjut: "",
    rtl_penanggung_jawab_id: null,
    rtl_penanggung_jawab_nama: "",
    rtl_deadline: "",
    eskalasi_ke: "",
  };

  selectedReasonIds: number[] = [];

  // Observation dialog
  showAddObservationDialog = false;
  newObs = this.emptyObservation();

  // Sign dialog
  showSignDialog = false;
  signTier = "";
  signPassword = "";

  // Delete observation confirm
  confirmHapusObs: any = null;

  // Pasien search
  selectedPasien: any = null;
  pasienSearchItems: any[] = [];
  pasienSearchLoading = false;
  pasienSearchLoaded = false;
  pasienSearchQuery = "";

  // Options (populated from API/static)
  unitOptions: any[] = [];
  dokterOptions: any[] = [];
  reasonDefinitions: any[] = [];

  statusDokterOptions = [
    { text: "Aktif", value: "aktif" },
    { text: "Cuti", value: "cuti" },
    { text: "Dinas Luar", value: "dinas_luar" },
    { text: "Libur", value: "libur" },
    { text: "Sakit", value: "sakit" },
  ];

  kondisiKhususOptions = [
    { text: "Normal", value: "normal" },
    { text: "Pulang Sebelum Visite", value: "pulang_sebelum_visite" },
    { text: "Meninggal Sebelum Visite", value: "meninggal_sebelum_visite" },
    { text: "Pindah Ruang", value: "pindah_ruang" },
    { text: "Menolak Visite", value: "menolak_visite" },
    { text: "Force Majeure", value: "force_majeure" },
  ];

  eskalasiOptions = [
    { text: "Komite Medik", value: "komite_medik" },
    { text: "Direktur Medis", value: "direktur_medis" },
    { text: "Bidang Pelayanan Medis", value: "bidang_pelayanan_medis" },
  ];

  obsHeaders = [
    { text: "No", value: "no", width: "40px", align: "center", sortable: false },
    { text: "No RM", value: "no_rekam_medis", width: "90px" },
    { text: "Nama Pasien", value: "nama_pasien" },
    { text: "Kamar", value: "ruang_kamar", width: "80px" },
    { text: "Status", value: "status_pasien", width: "70px", align: "center" },
    { text: "Kondisi Khusus", value: "kondisi_khusus", width: "160px" },
    { text: "Jam Visite", value: "jam_visite", width: "110px", align: "center" },
    { text: "Hasil", value: "hasil", width: "80px", align: "center" },
    { text: "Keterangan", value: "keterangan_sistem", width: "150px" },
    { text: "", value: "actions", width: "40px", sortable: false },
  ];

  get isEdit(): boolean {
    return !!this.sessionData;
  }

  get isLocked(): boolean {
    return (this.session && this.session.is_locked) || false;
  }

  get canEdit(): boolean {
    return (this.session && this.session.can_edit) || false;
  }

  get hasLainnya(): boolean {
    const lainnyaReason = this.reasonDefinitions.find((r: any) => r.kode === "lainnya");
    return lainnyaReason ? this.selectedReasonIds.includes(lainnyaReason.id) : false;
  }

  get signTierLabel(): string {
    const labels: any = {
      pencatat: "Petugas Pencatat",
      kepala_ruang: "Kepala Ruang",
      approver: "Komite Mutu / Direktur Medis",
    };
    return labels[this.signTier] || "";
  }

  get statusColor(): string {
    const map: any = {
      draft: "grey",
      submitted: "blue",
      verified: "orange",
      approved: "green",
    };
    return (this.session && map[this.session.status]) || "grey";
  }

  async mounted() {
    // Set petugas dari user login
    this.form.nama_petugas_id = userModule.user ? userModule.user.id : null;
    this.form.nama_petugas = userModule.user ? userModule.user.nama : "";

    // Load master data paralel
    await Promise.all([
      this.loadUnitRanap(),
      this.loadDokterList(),
      this.storeModule.loadReasonDefinitions(),
    ]);
    this.reasonDefinitions = this.storeModule.reasonDefinitions;

    // Load jika edit
    if (this.sessionData) {
      await this.loadSessionDetail(this.sessionData.id);
    } else {
      this.applyDefaultUnitFromUser();
    }
  }

  /**
   * Session baru: default Unit Ruang Rawat = unit user yang login
   * (hanya bila unit tsb ada di daftar unit ranap).
   */
  applyDefaultUnitFromUser() {
    const unitId = userModule.user ? userModule.user.unit_id : null;
    if (!unitId || this.form.unit_ruang_rawat) return;
    const item = this.unitOptions.find(
      (u: any) => String(u.value) === String(unitId)
    );
    if (!item) return;
    this.form.unit_ruang_rawat = item.value;
    this.form.unit_ruang_rawat_nama = item.text;
  }

  async loadUnitRanap() {
    try {
      const data = await Referensi.getUnitPelayanan();
      this.unitOptions = (data || [])
        .filter((u: any) => u.kategori === "ranap")
        .map((u: any) => ({
          text: u.nama,
          value: u.id,
        }));
    } catch {
      this.unitOptions = [];
    }
  }

  async loadDokterList() {
    try {
      const res = await http.getData("/combo/dokter");
      this.dokterOptions = (res.data || []).map((d: any) => ({
        text: d.nama,
        value: d.user_id,
        spesialisasi: (d.idsp && isNaN(Number(d.idsp))) ? d.idsp : null,
      }));
    } catch {
      this.dokterOptions = [];
    }
  }

  async loadSessionDetail(id: number) {
    await this.storeModule.loadSession(id);
    this.session = this.storeModule.currentSession;
    if (this.session) {
      this.populateForm(this.session);
    }
  }

  populateForm(data: any) {
    this.form.tanggal_observasi = data.tanggal_observasi;
    this.form.nama_petugas_id = data.nama_petugas_id;
    this.form.nama_petugas = data.nama_petugas;
    this.form.pic_nama = data.pic_nama || "";
    this.form.unit_ruang_rawat = data.unit_ruang_rawat;
    this.form.unit_ruang_rawat_nama = data.unit_ruang_rawat_nama;
    this.form.nama_dokter_spesialis_id = data.nama_dokter_spesialis_id;
    this.form.nama_dokter_spesialis = data.nama_dokter_spesialis;
    this.form.spesialisasi = data.spesialisasi;
    this.form.timezone = data.timezone;
    this.form.status_dokter_hari_ini = data.status_dokter_hari_ini;
    this.form.batas_waktu_standar = data.batas_waktu_standar;
    this.form.target_persen = data.target_persen;
    // Analisa
    this.form.penyebab_lainnya_detail = data.penyebab_lainnya_detail || "";
    this.form.rencana_tindak_lanjut = data.rencana_tindak_lanjut || "";
    this.form.rtl_penanggung_jawab_nama = data.rtl_penanggung_jawab_nama || "";
    this.form.rtl_deadline = data.rtl_deadline || "";
    this.form.eskalasi_ke = data.eskalasi_ke || "";

    this.selectedReasonIds = (data.reasons || []).map((r: any) => r.id);
  }

  async saveSession() {
    this.saving = true;
    try {
      if (this.isEdit && this.session) {
        const res = await Service.updateSession(this.session.id, this.form);
        this.session = res.data.data;
      } else {
        const res = await Service.createSession(this.form);
        this.session = res.data.data;
      }
      this.populateForm(this.session);
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
  }

  async saveAnalisa() {
    if (!this.session) return;
    this.saving = true;
    try {
      const payload = {
        rencana_tindak_lanjut: this.form.rencana_tindak_lanjut,
        penyebab_lainnya_detail: this.form.penyebab_lainnya_detail,
        rtl_penanggung_jawab_nama: this.form.rtl_penanggung_jawab_nama,
        rtl_deadline: this.form.rtl_deadline,
        eskalasi_ke: this.form.eskalasi_ke,
        reason_ids: this.selectedReasonIds,
      };
      const res = await Service.updateSession(this.session.id, payload);
      this.session = res.data.data;
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
  }

  async importPasien() {
    if (!this.session) return;
    this.importing = true;
    try {
      const res = await Service.importPasien(this.session.id);
      this.session = res.data.session;
      if (res.data.message) {
        this.pullSoapMessage = res.data.message;
        this.showPullSoapSnackbar = true;
      }
    } catch (e) {
      // Error handled by service
    }
    this.importing = false;
  }

  async pullSoap() {
    if (!this.session) return;
    this.pullingSoap = true;
    try {
      const res = await Service.pullSoap(this.session.id);
      this.session = res.data.session;
      this.pullSoapMessage = res.data.message || "Tarik SOAP selesai";
      this.showPullSoapSnackbar = true;
    } catch (e) {
      // Error handled by service
    }
    this.pullingSoap = false;
  }

  openAddObservationDialog() {
    this.showAddObservationDialog = true;
    this.newObs = this.emptyObservation();
    this.selectedPasien = null;
    this.pasienSearchQuery = "";
    this.loadAvailablePatients();
  }

  emptyObservation() {
    return {
      pasien_id: "",
      nama_pasien: "",
      no_rekam_medis: "",
      ruang_kamar: "",
      status_pasien: "lama",
      jenis_pasien: "sendiri",
    };
  }

  filterPasienLocal(item: any, queryText: string) {
    if (!queryText) return true;
    const q = queryText.toLowerCase();
    return (
      (item.rm || "").toLowerCase().indexOf(q) > -1 ||
      (item.nama || "").toLowerCase().indexOf(q) > -1 ||
      (item.ruang_kamar || "").toLowerCase().indexOf(q) > -1
    );
  }

  async loadAvailablePatients() {
    if (!this.session) return;
    this.pasienSearchLoading = true;
    this.pasienSearchLoaded = false;
    try {
      const res = await Service.getAvailablePatients(this.session.id);
      this.pasienSearchItems = res.data.data || [];
    } catch {
      this.pasienSearchItems = [];
    }
    this.pasienSearchLoading = false;
    this.pasienSearchLoaded = true;
  }

  onSelectPasien(val: any) {
    if (val) {
      this.newObs.pasien_id = val.cm || val.rm;
      this.newObs.nama_pasien = val.nama;
      this.newObs.no_rekam_medis = val.rm;
      this.newObs.ruang_kamar = val.ruang_kamar || "";
    } else {
      this.clearSelectedPasien();
    }
  }

  clearSelectedPasien() {
    this.selectedPasien = null;
    this.newObs.pasien_id = "";
    this.newObs.nama_pasien = "";
    this.newObs.no_rekam_medis = "";
    this.newObs.ruang_kamar = "";
  }

  async addObservation() {
    if (!this.session) return;
    try {
      await Service.createObservation(this.session.id, this.newObs);
      this.showAddObservationDialog = false;
      this.newObs = this.emptyObservation();
      this.selectedPasien = null;
      this.pasienSearchItems = [];
      this.pasienSearchQuery = "";
      await this.loadSessionDetail(this.session.id);
    } catch (e) {
      // Error handled by service
    }
  }

  async updateJamVisite(obs: any, val: string) {
    if (!this.session) return;
    try {
      await Service.updateObservation(this.session.id, obs.id, { jam_visite: val });
      await this.loadSessionDetail(this.session.id);
    } catch (e) {
      // Error handled by service
    }
  }

  async updateKondisiKhusus(obs: any, val: string) {
    if (!this.session) return;
    try {
      await Service.updateObservation(this.session.id, obs.id, { kondisi_khusus: val });
      await this.loadSessionDetail(this.session.id);
    } catch (e) {
      // Error handled by service
    }
  }

  async hapusObservasi() {
    if (!this.session || !this.confirmHapusObs) return;
    try {
      await Service.deleteObservation(this.session.id, this.confirmHapusObs.id);
      this.confirmHapusObs = null;
      await this.loadSessionDetail(this.session.id);
    } catch (e) {
      // Error handled by service
    }
  }

  // --- Signing ---
  openSignDialog(tier: string) {
    this.signTier = tier;
    this.signPassword = "";
    this.showSignDialog = true;
  }

  async confirmSign() {
    if (!this.session || !this.signPassword) return;
    this.signing = true;
    try {
      let res;
      if (this.signTier === "pencatat") {
        res = await Service.signPencatat(this.session.id, this.signPassword);
      } else if (this.signTier === "kepala_ruang") {
        res = await Service.signKepalaRuang(this.session.id, this.signPassword);
      } else if (this.signTier === "approver") {
        res = await Service.signApprover(this.session.id, this.signPassword);
      }
      if (res) {
        this.session = res.data.data;
        this.showSignDialog = false;
      }
    } catch (e) {
      // Error handled by service
    }
    this.signing = false;
  }

  // --- Unit & Dokter ---
  onUnitChange(val: string) {
    const item = this.unitOptions.find((u: any) => u.value === val);
    if (item) this.form.unit_ruang_rawat_nama = item.text;
  }

  onDokterChange(val: number) {
    const item = this.dokterOptions.find((d: any) => d.value === val);
    if (item) {
      this.form.nama_dokter_spesialis = item.text;
      if (item.spesialisasi) {
        this.form.spesialisasi = item.spesialisasi;
      }
    }
  }

  // --- Helpers ---
  hasilColor(hasil: string): string {
    if (hasil === "≤14.00") return "green";
    if (hasil === "eks") return "orange";
    if (hasil === "tidak") return "red";
    return "grey";
  }

  hasilLabel(hasil: string): string {
    if (hasil === "≤14.00") return "Tercapai";
    if (hasil === "eks") return "Eksklusi";
    if (hasil === "tidak") return "Tidak";
    return "-";
  }

  formatUmur(umur: any): string {
    if (!umur) return "-";
    if (typeof umur === "string" || typeof umur === "number") return umur + " th";
    const parts = [];
    if (umur.th) parts.push(umur.th + " th");
    if (umur.bln) parts.push(umur.bln + " bln");
    if (!umur.th && umur.hr) parts.push(umur.hr + " hr");
    return parts.join(" ") || "-";
  }

  formatDateTime(val: string): string {
    if (!val) return "-";
    return new Date(val).toLocaleString("id-ID");
  }
}
